<div class="row content content-dashboard">
    <ng-container *ngFor="let gCell of gridCells; let i = index">
        <div
            [@cellVisibility]="gridCells[i].visible"
            (@cellVisibility.start)="onAnimationEvent($event, i, 'START', 'GRID', true)"
            (@cellVisibility.done)="onAnimationEvent($event, i, 'END', 'GRID', gridCells[i].visible)"
            class="p-0 grid-cell" [class.should-be-visible]="gridCells[i].visible" [class.is-loading]="gridCells[i].visible && !gridCells[i].widget.visible"
        >
            <div
                [@avalancheVisibility]="!gridCells[i].widget.visible"
                (@avalancheVisibility.start)="onAnimationEvent($event, i, 'START', 'WIDGET', true)"
                (@avalancheVisibility.done)="onAnimationEvent($event, i, 'END', 'WIDGET', !gridCells[i].widget.visible)"
                class="avalanche-loader"
            >
                <!-- Desktop -->
                <div class="desktop edp-card-widget card avalanche">
                    <div class="animated-background">
                        <div class="background-masker left-top"></div>
                        <div class="background-masker middle"></div>
                        <div class="background-masker left-bottom"></div>
                        <div class="background-masker bottom"></div>
                        <div class="background-masker square-side"></div>
                        <div class="background-masker square-bottom"></div>
                        <div class="background-masker first-line"></div>
                        <div class="background-masker first-line-space"></div>
                        <div class="background-masker second-line-space"></div>
                        <div class="background-masker third-line"></div>
                        <div class="background-masker third-line-space"></div>
                    </div>
                </div>

                <!-- Mobile -->
                <div class="mobile edp-card-widget card avalanche">
                    <div class="animated-background">
                        <div class="background-masker mobile-top-line"></div>
                        <div class="background-masker mobile-top"></div>
                        <div class="background-masker mobile-left"></div>
                        <div class="background-masker mobile-right"></div>
                        <div class="background-masker mobile-bottom"></div>
                        <div class="background-masker mobile-left-space"></div>
                        <div class="background-masker mobile-middle-space"></div>
                        <div class="background-masker mobile-right-space"></div>
                        <div class="background-masker mobile-first-line"></div>
                        <div class="background-masker mobile-first-line-space"></div>
                        <div class="background-masker mobile-second-line"></div>
                        <div class="background-masker mobile-second-line-space"></div>
                    </div>
                </div>
            </div>

            <div class="widget">
                <ng-container #widget></ng-container>
            </div>
        </div>
    </ng-container>
</div>
